document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const mobileNav = document.getElementById('MobileNav');
  const openButton = document.querySelector('[data-mobile-nav-toggle]');
  const closeButton = document.querySelector('[data-mobile-nav-close]');

  const openNav = () => {
    if (!mobileNav) return;
    mobileNav.hidden = false;
    if (openButton) openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-nav-open');
  };

  const closeNav = () => {
    if (!mobileNav) return;
    mobileNav.hidden = true;
    if (openButton) openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-nav-open');
  };

  if (openButton) openButton.addEventListener('click', openNav);
  if (closeButton) closeButton.addEventListener('click', closeNav);
  if (mobileNav) {
    mobileNav.addEventListener('click', (event) => {
      if (event.target === mobileNav) closeNav();
    });
    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => closeNav());
    });
  }

  document.querySelectorAll('.hero-premium').forEach((container) => {
    const speed = parseInt(container.dataset.speed || '5000', 10);
    const autoplay = container.dataset.autoplay === 'true';
    const slides = Array.from(container.querySelectorAll('.hero-premium__slide'));
    const dots = Array.from(container.querySelectorAll('[data-slide-dot]'));
    if (!slides.length) return;

    let current = 0;
    const showSlide = (index) => {
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      current = index;
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => showSlide(index)));
    showSlide(0);

    if (autoplay && slides.length > 1) {
      setInterval(() => showSlide((current + 1) % slides.length), speed);
    }
  });


  document.querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-testimonial-track]');
    const prev = carousel.querySelector('[data-testimonial-prev]');
    const next = carousel.querySelector('[data-testimonial-next]');
    if (!track) return;

    const getScrollAmount = () => Math.max(280, Math.min(track.clientWidth * 0.92, 420));
    const updateButtons = () => {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }));

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();

    const autoplay = carousel.dataset.testimonialAutoplay === 'true';
    const speed = parseInt(carousel.dataset.testimonialSpeed || '6000', 10);
    let timer;

    const startAuto = () => {
      if (!autoplay || track.scrollWidth <= track.clientWidth) return;
      timer = window.setInterval(() => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 4) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
      }, speed);
    };

    const stopAuto = () => {
      if (timer) window.clearInterval(timer);
    };

    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('mouseleave', () => { stopAuto(); startAuto(); });
    carousel.addEventListener('focusin', stopAuto);
    carousel.addEventListener('focusout', () => { stopAuto(); startAuto(); });

    startAuto();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.product-media__image');
    const imageTrigger = gallery.querySelector('[data-product-main-image-trigger]');
    const thumbButtons = gallery.querySelectorAll('[data-product-thumb]');
    if (!mainImage) return;

    const setMainImage = (src, fullSrc, alt) => {
      if (!src) return;
      mainImage.setAttribute('src', src);
      mainImage.setAttribute('srcset', '');
      mainImage.setAttribute('sizes', '');
      if (alt) mainImage.setAttribute('alt', alt);
      if (imageTrigger) imageTrigger.setAttribute('data-product-full-image', fullSrc || src);
    };

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const src = button.getAttribute('data-product-image-src');
        const fullSrc = button.getAttribute('data-product-full-image') || src;
        const alt = button.getAttribute('data-product-image-alt') || mainImage.getAttribute('alt') || '';
        setMainImage(src, fullSrc, alt);
        thumbButtons.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });

    if (imageTrigger) {
      imageTrigger.addEventListener('click', () => {
        const lightbox = document.querySelector('[data-product-lightbox]');
        const lightboxImage = document.querySelector('[data-product-lightbox-image]');
        if (!lightbox || !lightboxImage) return;
        lightboxImage.setAttribute('src', imageTrigger.getAttribute('data-product-full-image') || mainImage.getAttribute('src'));
        lightboxImage.setAttribute('alt', mainImage.getAttribute('alt') || 'Product image');
        lightbox.hidden = false;
        document.body.classList.add('product-lightbox-open');
      });
    }

    document.querySelectorAll('[data-product-variant-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        const src = option.getAttribute('data-variant-image');
        const fullSrc = option.getAttribute('data-variant-full-image') || src;
        const alt = option.getAttribute('data-variant-image-alt') || mainImage.getAttribute('alt') || '';
        if (src) {
          setMainImage(src, fullSrc, alt);
          thumbButtons.forEach((item) => item.classList.remove('is-active'));
        }
        const skuNode = document.querySelector('[data-product-sku]');
        const sku = option.getAttribute('data-variant-sku');
        if (skuNode && sku) skuNode.textContent = sku;
      });
    });
  });

  document.querySelectorAll('[data-product-lightbox-close], [data-product-lightbox]').forEach((node) => {
    node.addEventListener('click', (event) => {
      if (event.target.matches('[data-product-lightbox]') || event.target.matches('[data-product-lightbox-close]')) {
        const lightbox = document.querySelector('[data-product-lightbox]');
        if (lightbox) lightbox.hidden = true;
        document.body.classList.remove('product-lightbox-open');
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const lightbox = document.querySelector('[data-product-lightbox]');
      if (lightbox && !lightbox.hidden) {
        lightbox.hidden = true;
        document.body.classList.remove('product-lightbox-open');
      }
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-catalog-grid]' ).forEach((grid) => {
    const scope = grid.closest('.collection-main') || document;
    const buttons = scope.querySelectorAll('[data-view-toggle]');
    if (!buttons.length) return;

    const setView = (view) => {
      grid.classList.toggle('is-list-view', view === 'list');
      buttons.forEach((button) => button.classList.toggle('is-active', button.dataset.viewToggle === view));
      try { window.localStorage.setItem('storagetekproCatalogView', view); } catch (e) {}
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => setView(button.dataset.viewToggle || 'grid'));
    });

    let savedView = 'grid';
    try { savedView = window.localStorage.getItem('storagetekproCatalogView') || 'grid'; } catch (e) {}
    setView(savedView === 'list' ? 'list' : 'grid');
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const section = carousel.closest('.related-products-section') || carousel;
    const prev = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    if (!track) return;

    const getScrollAmount = () => Math.max(260, Math.min(track.clientWidth * 0.88, 520));
    const updateButtons = () => {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });
});


/* Cart quantity auto-update */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cart-auto-update-form]').forEach((form) => {
    const updateButton = form.querySelector('[data-cart-update-button]');
    const statusNodes = form.querySelectorAll('[data-cart-quantity-status]');
    let timer;

    const setStatus = (message) => {
      statusNodes.forEach((node) => { node.textContent = message || ''; });
    };

    const submitCartUpdate = () => {
      window.clearTimeout(timer);
      setStatus('Updating…');
      timer = window.setTimeout(() => {
        if (updateButton && typeof form.requestSubmit === 'function') {
          form.requestSubmit(updateButton);
        } else {
          const hiddenUpdate = document.createElement('input');
          hiddenUpdate.type = 'hidden';
          hiddenUpdate.name = 'update';
          hiddenUpdate.value = 'Update cart';
          form.appendChild(hiddenUpdate);
          form.submit();
        }
      }, 450);
    };

    form.querySelectorAll('[data-cart-quantity-control]').forEach((control) => {
      const input = control.querySelector('[data-cart-quantity-input]');
      const minus = control.querySelector('[data-cart-quantity-minus]');
      const plus = control.querySelector('[data-cart-quantity-plus]');
      if (!input) return;

      const stepQuantity = (amount) => {
        const current = parseInt(input.value || '0', 10) || 0;
        input.value = Math.max(0, current + amount);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      if (minus) minus.addEventListener('click', () => stepQuantity(-1));
      if (plus) plus.addEventListener('click', () => stepQuantity(1));
      input.addEventListener('change', submitCartUpdate);
      input.addEventListener('blur', () => {
        if (input.value === '' || parseInt(input.value, 10) < 0) input.value = '0';
      });
    });
  });
});


/* Mobile collection filter drawer */
document.addEventListener('DOMContentLoaded', () => {
  const openButtons = document.querySelectorAll('[data-filter-open]');
  const closeButtons = document.querySelectorAll('[data-filter-close]');
  const overlay = document.querySelector('[data-filter-overlay]');
  const drawer = document.querySelector('[data-filter-drawer]');

  const openDrawer = () => {
    if (!drawer) return;
    document.body.classList.add('collection-filter-open');
    if (overlay) overlay.hidden = false;
    const firstFocusable = drawer.querySelector('button, a, input, select, summary');
    if (firstFocusable) firstFocusable.focus({ preventScroll: true });
  };

  const closeDrawer = () => {
    document.body.classList.remove('collection-filter-open');
    if (overlay) overlay.hidden = true;
  };

  openButtons.forEach((button) => button.addEventListener('click', openDrawer));
  closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  const collapseMobileFilters = () => {
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll('.collection-sidebar .filter-group[open]').forEach((detail) => detail.removeAttribute('open'));
    }
  };
  collapseMobileFilters();
});


// Mobile contact strip popups
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('[data-contact-popup]');
    if (!popup) return;
    var titleNode = popup.querySelector('[data-contact-popup-title]');
    var textNode = popup.querySelector('[data-contact-popup-text]');
    var linkNode = popup.querySelector('[data-contact-popup-link]');

    var tryOpenChat = function (customSelector) {
      var selectors = [];
      if (customSelector) selectors.push(customSelector);
      selectors = selectors.concat([
        '#ShopifyChat',
        '[data-shopify-chat]',
        '[aria-label*="chat" i]',
        '[aria-label*="message" i]',
        '[class*="chat" i] button',
        '[class*="chat" i]',
        '[id*="chat" i]',
        '[class*="contact" i] button',
        '[class*="launcher" i]',
        'iframe[title*="chat" i]',
        'iframe[title*="message" i]',
        'iframe[src*="chat" i]'
      ]);

      for (var i = 0; i < selectors.length; i++) {
        try {
          var node = document.querySelector(selectors[i]);
          if (node && node !== trigger && node.offsetParent !== null) {
            node.click();
            return true;
          }
        } catch (e) {}
      }
      return false;
    };

    document.querySelectorAll('[data-contact-popup-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var action = trigger.getAttribute('data-contact-action') || 'popup';
        var link = trigger.getAttribute('data-popup-link') || '';
        if (action === 'link' && link && link !== '#') {
          window.location.href = link;
          return;
        }
        if (action === 'chat') {
          var selector = trigger.getAttribute('data-chat-selector') || '';
          if (tryOpenChat(selector)) return;
        }

        var title = trigger.getAttribute('data-popup-title') || '';
        var text = trigger.getAttribute('data-popup-text') || '';
        var linkLabel = trigger.getAttribute('data-popup-link-label') || '';
        if (titleNode) titleNode.textContent = title;
        if (textNode) textNode.textContent = text;
        if (linkNode) {
          if (link && link !== '#') {
            linkNode.hidden = false;
            linkNode.setAttribute('href', link);
            linkNode.textContent = linkLabel || 'Learn more';
          } else {
            linkNode.hidden = true;
          }
        }
        popup.hidden = false;
        document.body.classList.add('contact-popup-open');
      });
    });

    popup.querySelectorAll('[data-contact-popup-close]').forEach(function (node) {
      node.addEventListener('click', function () {
        popup.hidden = true;
        document.body.classList.remove('contact-popup-open');
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) {
        popup.hidden = true;
        document.body.classList.remove('contact-popup-open');
      }
    });
  });
})();
